import { useEffect, useState } from 'react';
import { authService } from '../../services/auth';

/** 按平台与用户保存展示偏好，仅影响 UI；退出或切账号重新读取自己的设置。 */
export function useThinkingPreference(): [boolean, () => void] {
  /** 本地偏好键不含令牌，不共用其他账号的配置。 */
  const identityKey = () => `bomate-thinking:${authService.getBaseUrl()}:${authService.getAuthState()?.user.id ?? 'anonymous'}`;
  /** 隐私模式或无设置时默认展示折叠入口。 */
  const read = () => { try { return localStorage.getItem(identityKey()) !== 'hidden'; } catch { return true; } };
  const [visible, setVisible] = useState(read);
  useEffect(() => authService.subscribe(() => setVisible(read())), []);
  return [visible, () => setVisible(old => {
    const value = !old;
    try { localStorage.setItem(identityKey(), value ? 'visible' : 'hidden'); } catch { /* 存储不可用时只在本页生效。 */ }
    return value;
  })];
}
